module.exports = __webpack_public_path__ + "Montserrat-Regular.5e077c1.ttf";